// How far from you "Sheltered from the wind" looks: 2 km (from the shore), 5 km, 10 km (by boat).
// Set in Asetukset → profile (tips.ts) and with the chips in the search sheet (shelter-ui.ts); kept on the phone.
import { lsGet, lsSet } from "../util.ts";

export const SHELTER_KMS = [2, 5, 10] as const;
export type ShelterKm = (typeof SHELTER_KMS)[number];
export function shelterKm(): ShelterKm {
  const v = Number(lsGet("shelterKm", "5"));
  return (SHELTER_KMS as readonly number[]).includes(v) ? (v as ShelterKm) : 5;
}
export const setShelterKm = (km: ShelterKm): void => lsSet("shelterKm", String(km));
/** How many spots to suggest: a wider area gets more. */
export const shelterCount = (km: ShelterKm): number => ({ 2: 5, 5: 8, 10: 12 })[km];
